export const PUSH_FILES = 'media:files:push';
export const SET_PROGRESS = 'media:progress:set';
export const SET_UPLOADED_URLS = 'media:uploadedUrls:set';
export const SET_UPLOADING = 'media:uploading:set';
export const SET_ERROR = 'media:error:set';
export const SET_DRAG_ACTIVE = 'media:drag:set:active';
export const DELETE_PENDING_FILE = 'media:files:delete:pending';
export const CLEAR_PENDING_FILES = 'media:files:clear:pending';
export const RESET_MEDIA_STATE = 'media:state:reset';
export const UPLOAD_FILES = 'media:files:upload';
